import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/cloud-moon-rain.vue
var o = {
	name: "DtIconCloudMoonRain",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--cloud-moon-rain"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Cloud Moon Rain",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [
		r("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M7.016 2.702a2.5 2.5 0 0 0-1.482 1.881.5.5 0 1 1-.985-.166A3.501 3.501 0 0 1 7.999 1.5a.5.5 0 0 1 .36.849 1.621 1.621 0 0 0 2.292 2.293A.5.5 0 0 1 11.5 5a3.498 3.498 0 0 1-1.75 3.031.5.5 0 1 1-.5-.865c.466-.27.836-.685 1.05-1.183a2.621 2.621 0 0 1-3.284-3.281Z",
			fill: "currentColor"
		}, null, -1),
		r("path", {
			d: "M3.552 6.502A2 2 0 0 0 1.9 9.7a.5.5 0 1 1-.8.6 3 3 0 0 1 4.79-3.614c.188.248.32.814.32.814s.134.65-.386.65c-.168 0-.608.037-.608-.559 0-.596-.915-1.09-1.664-1.09Z",
			fill: "currentColor"
		}, null, -1),
		r("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M5.5 9.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5Zm-2-.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5Z",
			fill: "currentColor"
		}, null, -1)
	])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=cloud-moon-rain.js.map